import React from "react";
import Paginator from "./Paginator.jsx";
import Flash from "./Flash.jsx";
import Currency from "./currency.js";
class Invoices extends React.Component {
  constructor(props){
    super(props);
    this.RESULTS_PER_PAGE = 10;
    this.state = {
      invoices: [],
      count: 0,
      page: 0,
      limit: this.RESULTS_PER_PAGE,
      flash_messages: [],
      flash_timestamp: ""
    };

    this.retrieve_invoices = this.retrieve_invoices.bind(this);

  }

  componentDidMount(){
    this.retrieve_invoices(this.state.page, this.RESULTS_PER_PAGE);
  }

  retrieve_invoices(page, limit){
    fetch(`/invoices?offset=${page*this.RESULTS_PER_PAGE}&limit=${limit}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'/*,
        'x-csrf-token': this.csrf_token()*/
      }
    }).then((response) => {
      return response.json();
    }).then((json) => {
      if (!json.invoices){
        return Flash.add_message(this, "Error encountered in retrieving Payments.", 'danger', 5);
      }
      this.setState({
        page: page,
        invoices: json.invoices,
        count: json.count
      });
    })
  }

  render () {
    return (
        <div className="psintegril-card">
          <Flash messages={this.state.flash_messages} timestamp={this.state.flash_timestamp} on_update={(flash_state) => this.setState(flash_state)} />
          <h1>Invoices</h1>
          <div className="psintegril-table-container">
            <table className="psintegril-table">
              <tbody>
                <tr>
                  <th>
                    Date ({String(new Date()).slice(25,33)})
                  </th>
                  <th>
                    Customer
                  </th>
                  <th>
                    Amount
                  </th>
                  <th>
                    Status
                  </th>
                  <th>
                    PDF
                  </th>
                </tr>
                {this.state.invoices.map(
                  (invoice, index) => 
                  <tr key={index}>
                    <td>
                      {String(new Date(invoice.created_at)).slice(4,24)}
                    </td>
                    <td>
                      <a href={`/s/customers/${invoice.customer_id}`}>{invoice.customer_id}</a>
                    </td>
                    <td>
                      {invoice.currency.toUpperCase()} {Currency.display(invoice.total_amount, invoice.currency)}
                    </td>
                    <td>
                      {invoice.status}
                    </td>
                    <td>
                        <a href={`/invoices/${invoice.id}/generate_pdf`} target="_blank">
                            INV{Array(4-String(invoice.invoice_number).length).fill('0').join('')}{invoice.invoice_number}
                        </a>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <Paginator on_page_change={(page) => {
            this.setState({page: page});
            this.retrieve_invoices(page, this.RESULTS_PER_PAGE);
          }} results={this.state.count} per_page={this.RESULTS_PER_PAGE} page={this.state.page} />
        </div>
    );
  }
}

export default Invoices;
